import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutResponsibilitySalesActivityReport extends Layout {
    checkboxIncludeRemarks: Checkbox;
    checkboxPageBreak: Checkbox;
    excludabletextboxCustomerId: ExcludableTextbox;
    excludabletextboxMarketingActivityId: ExcludableTextbox;
    excludabletextboxOperationsUser: ExcludableTextbox;
    excludabletextboxSalesManagerId: ExcludableTextbox;
    excludabletextboxSalespersonId: ExcludableTextbox;
    sourceResponsibilitySalesActivityReport: DataSource;
    textboxActionDate: Textbox;
    textboxActivityType: Textbox;
    textboxCustomerProspectType: Textbox;
    textboxGroupBy: Textbox;
    textboxHierarchyCode: Textbox;
    textboxHierarchyLevel: Textbox;
    textboxSortBy: Textbox;
}
